import { Badge, TextWithDescription } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type KmContextAttributeTitleProps = {
  name: string;
  code: string;
  /** Атрибут назначен на уровне и уже приходит сверху */
  isRepeat?: boolean;
};

/** Заголовок строки атрибута контекста оценки: название, код и отметка повтора */
export const KmContextAttributeTitle: FC<KmContextAttributeTitleProps> = ({ name, code, isRepeat = false }) => {
  const { t } = useTranslation('expertReport');

  return (
    <div className="flex min-w-0 items-center gap-2">
      <TextWithDescription
        text={<span>{name}</span>}
        description={<span className="font-mono text-sm font-medium">{code}</span>}
      />
      {isRepeat && (
        <Badge variant="secondary" outline className="shrink-0">
          {t('km.contextRepeat')}
        </Badge>
      )}
    </div>
  );
};
